import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { H1 } from '@fastnorth/kraken/components/typography';
import { Div } from '@fastnorth/kraken/components/layout';
import { CardSkeleton } from '@fastnorth/kraken/components/card';
import { useResponsive } from '@fastnorth/kraken/components/page-layout';

const EventProgressSkeleton = (): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa' });
  const { isMobile } = useResponsive();
  return (
    <Div className={'w-full'} data-testid={'event-progress-skeleton'}>
      <H1 fontWeight={'semibold'} size={'3xl'}>
        {t('page_titles.progress')}
      </H1>
      <Div className={'flex-wrap md:flex'}>
        {[{ id: 1 }, { id: 2 }, { id: 3 }].map(({ id }) => (
          <Div
            key={`skeleton-${id}`}
            className={`${isMobile ? 'w-full' : 'w-[300px]'}`}
            spacing={'4 2'}
            data-testid={`card-skeleton-container-${id}`}>
            {Array.from({ length: 2 }, (_, idx) => idx).map((id) => (
              <CardSkeleton key={`skeleton-${id}`} spacing={'2 4'} header={true} />
            ))}
          </Div>
        ))}
      </Div>
    </Div>
  );
};

export default EventProgressSkeleton;
